import { red, brown, blue, orange, green, blueGrey, grey } from "@mui/material/colors";
export const exchangeTypeToColor = {
    protein: red[400],
    starch: brown[500],
    fat: blue[400],
    fruit: orange[400],
    vegetable: green[400],
    dairy: blueGrey[400],
    "%future added value": grey[400],
};
//# sourceMappingURL=styles.js.map